import DynamicSectionElement from '@/scripts/dynamic-section-element.js'

import { handleLinksClick } from '@/scripts/datalayer'
import { disablePageScroll, enablePageScroll } from 'scroll-lock'

class SiteHeader extends DynamicSectionElement {
  constructor() {
    super();

    const rootStyle = document.documentElement.style
    rootStyle.setProperty('--visible-header-height', `${this.offsetHeight}px`)

    window.addEventListener('resize', () => {
      rootStyle.setProperty('--visible-header-height', `${this.offsetHeight}px`)
    })

    const isTablet = window.innerWidth >=1024 && window.innerWidth <=1280

    if (isTablet) {
      document.body.classList.add('is-tablet')
    }

    const els = document.querySelectorAll('.js-datalayer-cart-icon, .js-datalayer-wishlist-icon, .js-datalayer-account-icon, .js-datalayer-menu-item, .js-datalayer-logo')
    handleLinksClick(els)
    const menuItems = document.querySelectorAll('.js-main-menu-item');
    menuItems.forEach(item => {
      
      if (isTablet) {
        item.addEventListener('click', (e) => {
          if (item.classList.contains('active')) {
            enablePageScroll()
            item.classList.remove('active')
            isHovered = false 
          } else {
            timeout = setTimeout(() => {
              menuItems.forEach(i => i.classList.remove('active'))
              item.classList.add('active')
              const hasSub = item.getAttribute('data-submenu') === 'true'
              if (hasSub) {
                disablePageScroll()
              }
            }, 150)
          }
        })
      } else {
        let timeout
        let isHovered = false
        item.addEventListener('mouseover', () => {
          if (!isHovered) {
            timeout = setTimeout(() => {
              menuItems.forEach(i => i.classList.remove('active'))
              item.classList.add('active')
              const hasSub = item.getAttribute('data-submenu') === 'true'
              if (hasSub) {
                disablePageScroll()
              }
            }, 150)
          }
        })

        item.addEventListener('mouseout', () => {
          clearTimeout(timeout)
          isHovered = false
          enablePageScroll()
        })
      }
    })

    let wait = false

    document.addEventListener('mousemove', (e) => {
      if (!wait) {
        if (!e.target.closest('.js-main-menu')) {
          const menuItems = document.querySelectorAll('.js-main-menu-item')

          menuItems.forEach(i =>  {
            if (i.classList.contains('active')) {
              i.classList.remove('active')
              enablePageScroll()
            }
          })

          wait = true
          setTimeout(() => {
            wait = false
          }, 2000)
        }
      }

    })
  }
}

// Use base DynamicSectionElement class to enable replacing of content loaded from Section Rendering API
customElements.define('site-header', SiteHeader)
